"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/OrgPicker/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _user = require('shared/selectors/user');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _hooks = require('web/services/hooks');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Tooltip = require('web/components/Tooltip');
var _icons = require('web/screens/Inbox/InboxList/icons');






/* The inbox header's switcher block, for the Directory: the people tile,
 * "Directory", and the org under it. With two or more orgs it opens the
 * inbox's picker popover; with one it is a plain label. */
const OrgPicker = ({ selectedOrgKey, onSelectOrg }) => {
  const orgs = _hooks.useAppSelector.call(void 0, _user.selectMyActiveOrgsList)
  const { isOpen, onOpen, onClose } = _useToggle2.default.call(void 0, )
  const selectedOrg = _react.useMemo.call(void 0, 
    () => orgs.find(org => org.OrgKey === selectedOrgKey),
    [orgs, selectedOrgKey],
  )
  const isStatic = orgs.length < 2 && !!selectedOrgKey

  const onKeyDown = _react.useCallback.call(void 0, (e) => {
    if (e.key !== ' ' && e.key !== 'Enter') return
    e.preventDefault()
    onOpen()
  }, [onOpen])

  const subtitle = _optionalChain([selectedOrg, 'optionalAccess', _ => _.Name])
    || (orgs.length ? 'Pick an organization' : 'No organization')

  const block = (
    _react2.default.createElement('div', {
      className: _classBuilder2.default.call(void 0, 
        'inbox-list-header--picker',
        isOpen && 'is-open',
        isStatic && 'inbox-list-header--picker---static',
      ),
      ...(!isStatic && {
        "role": 'button',
        "tabIndex": 0,
        'aria-haspopup': 'true',
        'aria-expanded': isOpen,
        "onClick": onOpen,
        onKeyDown,
      }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}

      , _react2.default.createElement('div', { className: "inbox-list-header--logo directory-header--logo" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
        , _react2.default.createElement(_icons.TeamIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}} )
      )
      , _react2.default.createElement('div', { className: "inbox-list-header--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
        , _react2.default.createElement('div', { className: "inbox-list-header--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
          , _react2.default.createElement('span', { className: "inbox-list-header--name-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}, "Directory")
          ,  !isStatic && _react2.default.createElement(_icons.ChevronDownIcon, { size: 20, className: "inbox-list-header--chevron", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} ) 
        )
        , _react2.default.createElement('div', { className: "inbox-list-header--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}},  subtitle )
      )
    )
  )

  if (isStatic) return _react2.default.createElement('div', { className: "inbox-list-header--picker-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}},  block )

  const content = (
    _react2.default.createElement(_Tooltip.TooltipContent, { className: "inbox-picker", 'aria-roledescription': "Organization picker" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
      ,  orgs.map(o => {
        const isSelected = selectedOrgKey === o.OrgKey
        return (
          _react2.default.createElement(_Tooltip.TooltipItem, {
            key: o.OrgKey,
            className: "inbox-picker--item",
            'aria-selected': isSelected,
            selected: isSelected,
            onClick: () => { onClose(); onSelectOrg(o.OrgKey) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}

            , _react2.default.createElement('span', { className: "inbox-picker--item-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}},  o.Name )
            ,  isSelected && _react2.default.createElement(_icons.CheckIcon, { className: "inbox-picker--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}} ) 
          )
        )
      })
    )
  )

  return (
    _react2.default.createElement(_Tooltip.ControlledTooltip, {
      hideArrow: true,
      isDismissibleByClickElsewhere: true,
      place: "bottom-left",
      isOpen: isOpen,
      onClose: onClose,
      content: content,
      className: "inbox-list-header--picker-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}

      ,  block 
    )
  )
}

exports. default = _react.memo.call(void 0, OrgPicker)
